import { Component, h } from 'preact';

import AnalysisTableRow from './AnalysisTableRow';

import { APTotalVotesToCount } from '../election-utils';
import tooltipHTML from '../utils/tooltip-html';

import { SENATE, SHOWCASE_COLORS } from '../colors';

import { showPrecinctsReporting } from '../endpoints';

import countiesData from 'Data/data.json';
import context from 'Data/text.json';

type Props = {
  contest: { [key: string]: any },
};

class AnalysisTable extends Component<Props> {
  constructor() {
    super();
  }

  render() {
    const { contest, candidates, counties, linkBase } = this.props;

    let candidatesRender, sourceMap;

    if (contest) {
      let candidates = contest.candidacies;


      candidatesRender = (SHOWCASE_COLORS[contest.office] || SENATE).map((object) => {
        const result = candidates
          .filter((obj) => obj.name == object.name)
          .map((obj) => obj.id);
        return { ...object, id: result[0] };
      });

      sourceMap = contest.source;
    }


    function groupBy(arr, criteria) {
      const newObj = arr.reduce(function (acc, currentValue) {
        if (!acc[currentValue[criteria]]) {
          acc[currentValue[criteria]] = [];
        }
        const findCounties = counties
          .filter((county) => county.county == currentValue['county'])
          .map((obj) => obj.results)[0];
        const findCounties2 = counties
          .filter((county) => county.county == currentValue['county'])
          .map((obj) => APTotalVotesToCount(obj['eevp'], obj['total_votes']))[0];
        let arrayCounties = {
          ...currentValue,
          ...findCounties,
          estimated_votes: findCounties2,
        };

        acc[currentValue[criteria]].push(arrayCounties);
        return acc;
      }, {});

      const summedEntries = [];

      Object.entries(newObj).forEach(function (val, idx) {
        const result = val[1].reduce((r, e, i, a) => {
          const candidateIds = Object.keys(e);
          candidateIds.forEach((k) => (r[k] = (r[k] || 0) + parseInt(e[k])));

          if (!a[i + 1])
            Object.keys(e)
              .filter((k) => typeof e[k] == 'string')
              .forEach((k) => (r[k] /= val[1].length));
          r['category'] = e.category;
          delete r['county'];
          delete r['county_CAPS'];

          return r;
        });

        summedEntries.push(result);
      });
      return summedEntries;
    }





    function createArray(arr, criteria) {
      const newObj = arr.reduce(function (acc, currentValue) {
        if (!acc[currentValue[criteria]]) {
          acc[currentValue[criteria]] = [];
        }
        acc[currentValue[criteria]].push(currentValue);
        return acc;
      }, []);

      Object.entries(newObj).forEach(function (item, idx) {
        function sum(obj) {
          var sum = 0;
          var arrayToGetMost = [];
          for (var el in obj) {
            if (el !== 'category' && el !== 'estimated_votes') {
              sum += parseFloat(obj[el]);
              arrayToGetMost.push(obj[el]);
            }
          }
          return [sum, arrayToGetMost];
        }
        var totals = sum(item[1][0]);
        item[1][0].total_votes = totals[0];
        item[1][0].votes_still_to_count =
          item[1][0].estimated_votes - totals[0];
        totals[1].push(item[1][0].estimated_votes - totals[0]);
        item[1][0].largest_number = Math.max(...totals[1]);
        delete item[1][0].category;
      });
      return newObj;
    }

    const countiesByCategory = groupBy(countiesData.counties, 'category');

    const arrayByCategories = createArray(countiesByCategory, 'category');


    const objectCategories = Object.entries(arrayByCategories);


    let arrayToGetLargest = [];

    var sumofVotesLeftToCount = 0;

    objectCategories.forEach((item) => {
      arrayToGetLargest.push(item[1][0].largest_number);
      sumofVotesLeftToCount += item[1][0].votes_still_to_count;
    });


    return (
      <span>
        <h3 class='category__title t-sans'>
          {context.categories_headline}
          <span class='category__info'>
            <button
              type='button'
              class='category__info-pill'
              aria-label='How we define these regions'
              aria-describedby='category-info-tooltip'
            >
              ?
            </button>
            {context.regions_tooltip && (
              <span
                id='category-info-tooltip'
                role='tooltip'
                class='category__info-tooltip'
                dangerouslySetInnerHTML={{
                  __html: tooltipHTML(
                    context.regions_tooltip
                      .map((item) => item.value)
                      .join(' '),
                    linkBase
                  ),
                }}
              />
            )}
          </span>
        </h3>
        <div class='category-grids t-sans'>
          {objectCategories && objectCategories.map((categories) => (
            <AnalysisTableRow
              contest={contest}
              category={categories[0]}
              maxNum={Math.max(...arrayToGetLargest)}
              categoryNumbers={categories}
              candidates={candidates}
              candidatesRender={candidatesRender}
              linkBase={linkBase}
            />
          ))}
        </div>
        {/* {sumofVotesLeftToCount > 0 && showPrecinctsReporting == true && (
          <ul class='graphic-footer'>
            <li data-note>Note: {context.categories_notes}</li>
          </ul>
        )} */}
      </span>
    );
  }
}

export default AnalysisTable;